import React from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { get, size, split, max } from "lodash";

import Grid from "@material-ui/core/Grid";

import EllipsedTextNew from "../../Common/EllipsedTextNew";

import colors from "../../../assets/style/colors";

const styles = {
  item: {
    lineHeight: "50px",
    fontSize: "1.125em",
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: colors.primary,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const BreadcrumbItem = (props) => {
  const { classes, item, pathSize, itemMaxWidth } = props;

  const pathname = split(props.history.location.pathname, "/");

  const maxWidth =
    pathSize === 0
      ? itemMaxWidth
      : max([itemMaxWidth, parseInt((window.innerWidth * 0.6) / pathSize)]);

  return (
    <Grid
      item
      className={classes.item}
      style={{
        maxWidth: maxWidth,
      }}
    >
      <Grid container direction="column" justify="center" wrap="nowrap">
        <Grid
          item
          className="text-87"
          style={{
            lineHeight: get(item, ["subName"]) ? "16px" : "",
            whiteSpace: "nowrap",
            display: "flex",
          }}
        >
          <EllipsedTextNew
            title={get(item, ["name"])}
            text={
              get(item, ["url"]) ? (
                <Link
                  className={classes.link}
                  to={(location) => ({
                    //...location,
                    pathname: get(item, ["keepSection"])
                      ? `${get(item, ["url"])}/${get(pathname, [
                          size(pathname) - 1,
                        ])}`
                      : get(item, ["url"]),
                  })}
                >
                  {get(item, ["name"])}
                </Link>
              ) : (
                get(item, ["name"])
              )
            }
            maxWidth={maxWidth}
          />
        </Grid>
        {get(item, ["subName"]) && (
          <Grid
            item
            className="text-87"
            style={{
              fontSize: "0.857em",
              lineHeight: "14px",
            }}
          >
            {get(item, ["subName"])}
          </Grid>
        )}
      </Grid>
      {get(item, ["description"]) && (
        <Grid
          item
          className="text-54 text-italic"
          style={{ fontSize: "0.876em", paddingLeft: "20px" }}
        >
          {get(item, ["description"])}
        </Grid>
      )}
    </Grid>
  );
};

export default withRouter(withStyles(styles)(BreadcrumbItem));
